import { CanvasEyeButton } from '@/document-render/presentation/editing/quote/CanvasEyeButton';

export function SignatureQuoteLine({
  fieldId,
  label,
  visible,
  onToggle
}: {
  fieldId: string;
  label: string;
  visible: boolean;
  onToggle: (fieldId: string, nextVisible: boolean) => void;
}) {
  return (
    <div data-signature-line={fieldId} style={{ opacity: visible ? 1 : 0.5 }}>
      <CanvasEyeButton label={`${visible ? 'Hide' : 'Show'} ${label}`} pressed={visible} onToggle={() => onToggle(fieldId, !visible)} />
    </div>
  );
}
